
<br>
<div>
  <p style="font-size:350%"><strong>Track Info</strong> </p> 
</div>

<h4 align="right">
  <button type="button" class="btn btn-link">
    <a [routerLink]="['/home']">Back to shopping</a>
  </button>
</h4>


<table class="table table-hover">
  <thead>
    <tr style="font-size:130%; text-align: center">
      <th scope="col">ID</th>
      <th scope="col">NAME</th>
      <th scope="col">TOTAL PRICE</th>
      <th scope="col">COMMENT</th>
    </tr>
  </thead>
  <tbody style="font-size:130%; text-align: center">
    <tr *ngFor="let item of items">
      <td>{{item.subProdId}}</td>
      <td>{{item.subProductName}}</td>
      <td style="font-size:150%;">₹ {{item.price - (item.price * 0.1) | number }}</td>
      <td><a (click)="tracking()">Track</a></td>
    </tr>
    <tr>
        <td>{{one_prod.subProdId}}</td>
        <td>{{one_prod.subProductName}}</td>
        <td style="font-size:150%;">₹ {{one_prod.price - (one_prod.price * 0.1) | number }}</td>
        <td><a (click)="tracking()">Track</a></td>
      </tr>
  </tbody>
</table>